export enum ClaimDocumentType {
    INVOICE = 'invoice_Ext',
    REPAIR_ESTIMATE = 'repairestimate',
    PHOTOGRAPH = 'photo_Ext',
    OTHER = 'other',
    SHIPPING_LABEL = 'shipping_label',
    BOX_TOP = 'box_top',
    BOX_BOTTOM = 'box_bottom',
    DAMAGED = 'damaged',
    PACKAGING_MATERIALS_OUTER = 'packaging_materials_outer',
    PACKAGING_MATERIALS_INNER = 'packaging_materials_inner',
}
